import { render, staticRenderFns } from "./Dialog_LeaseCargoShop.vue?vue&type=template&id=9b6e9f90&scoped=true&"
import script from "./Dialog_LeaseCargoShop.vue?vue&type=script&lang=js&"
export * from "./Dialog_LeaseCargoShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b6e9f90",
  null
  
)

export default component.exports